import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import "./styles.css";

const router = getRouter();

const rootElement = document.getElementById("root");
if (rootElement) {
  if (rootElement.hasChildNodes() && rootElement.innerHTML.trim().length > 0) {
    try {
      ReactDOM.hydrateRoot(
        rootElement,
        <React.StrictMode>
          <RouterProvider router={router} />
        </React.StrictMode>
      );
    } catch (e) {
      console.warn("Hydration failed, falling back to client render:", e);
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <RouterProvider router={router} />
        </React.StrictMode>
      );
    }
  } else {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    );
  }
}
